const values = [
  "guild_reward_chest_g1",
  "guild_reward_chest_g2",
  "guild_reward_chest_s1",
  "guild_reward_chest_s2",
  "guild_reward_chest_w1",
  "guild_reward_chest_w2",
];
export default values;
